<script>
    // atoms/Container.svelte

    // Example:
    // <Container height={2} dense={true} br="0.2rem">
    //     <p>Some Cool Stuff</p>
    // </Container>

    export let height = 1;
    export let dense = false;
    export let br = "2rem";
    
    $: heightClass = `height-${height}`;
    $: paddingClass = dense ? 'padding-dense' : 'padding-norm';

    $: if (height > 3) {
        heightClass = "height-3";
    }
    $: if (height < 1) {
        heightClass = "height-1";
    }
</script>

<div 
    style="border-radius: {br};"
    class="container {heightClass} {paddingClass}">
    <slot></slot>
</div>

<style>
    .container {
        background-color: white;
    }

    .padding-norm {
        padding: 1rem;
    }

    .padding-dense {
        padding: 0.4rem;
    }

    .height-1 {
        box-shadow: none;
    }

    .height-2 {
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12);
    }

    .height-3 {
        box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12);
    }
</style>
